<div class="dlg-wrap" dir="rtl">

  <!-- ════════════════════════════════════════
  Compact top bar
  ════════════════════════════════════════ -->
  <div class="dlg-topbar">

    <!-- right: type chip + title -->
    <div class="dlg-topbar__right">
      <span class="dlg-type-chip">
        <i class="fas"
          [class.fa-car-alt]="namespace === 'car'"
          [class.fa-building]="namespace === 'nadlan'"
          [class.fa-tag]="namespace !== 'car' && namespace !== 'nadlan'">
        </i>
        {{ namespace === 'car' ? 'רכב' : namespace === 'nadlan' ? 'נדל"ן' : 'מכירה' }}
      </span>
      <h2 class="dlg-title">{{ adsItem?.name }}</h2>
    </div>

    <!-- left: status + edit actions + close -->
    <div class="dlg-topbar__left">
      @if (editMode) {
        <button class="dlg-edit-save" (click)="saveEdits()" [disabled]="saving">
          {{ saving ? 'שומר...' : 'שמירת שינויים' }}
        </button>
        <button class="dlg-edit-cancel" (click)="cancelEdit()" [disabled]="saving">ביטול</button>
      } @else {
        <span class="status-pill"
          [class.active]="adsItem?.statusAds === StatusAds.Active || adsItem?.statusAds === StatusAds.Done"
          [class.pending]="adsItem?.statusAds === StatusAds.inReview || adsItem?.statusAds === StatusAds.Pause || adsItem?.statusAds === StatusAds.PayPending || adsItem?.statusAds === StatusAds.NeedsFix"
          [class.inactive]="adsItem?.statusAds === StatusAds.Delete || adsItem?.statusAds === StatusAds.Blocked || adsItem?.statusAds === StatusAds.Cancelled">
          <span class="dot"></span>
          {{ getStatusDesc(adsItem?.statusAds) | translate }}
        </span>
      }
      <button class="dlg-close" (click)="closeDialog()" aria-label="סגור">✕</button>
    </div>
  </div>

  <!-- ════════════════════════════════════════
  Body — sidebar + main
  ════════════════════════════════════════ -->
  <div class="dlg-body">

    <!-- ── Sidebar ── -->
    <div class="dlg-sidebar">

      <!-- Thumbnail -->
      @if (adsItem?.images?.length) {
        <div class="dlg-thumbnail">
          <img [src]="adsItem.images[0].image" alt="{{ adsItem?.name }}">
        </div>
      }

      <!-- Key info -->
      <div class="info-card">
        @if (adsItem?.price || editMode) {
          <div class="info-row">
            <span class="info-label">מחיר</span>
            @if (editMode) {
              <input type="number" class="edit-input edit-input--price" [(ngModel)]="editablePrice" name="editablePrice" min="0">
            } @else {
              <span class="info-price">₪{{ adsItem.price | number }}</span>
            }
          </div>
        }
        @if (adsItem?.price) {
          <div class="info-divider"></div>
        }
        <div class="info-row">
          <span class="info-label">פורסם</span>
          <span class="info-value">{{ adsItem?.createTime | date:'dd/MM/yy' }}</span>
        </div>
        <div class="info-divider"></div>
        <div class="info-row">
          <span class="info-label">עודכן</span>
          <span class="info-value">{{ adsItem?.updateTime | date:'dd/MM/yy' }}</span>
        </div>
        @if (adsItem?.adsRoute?.title) {
          <div class="info-divider"></div>
          <div class="info-row">
            <span class="info-label">חבילה</span>
            <span class="info-value">{{ adsItem.adsRoute.title }}</span>
          </div>
        }
      </div>

      <!-- Actions -->
      <div>
        <div class="sidebar-label">פעולות</div>
        <app-ads-controls [adsItem]="adsItem" (adsItemChange)="onAdsItemChange($event)"></app-ads-controls>
      </div>

      <!-- Share -->
      <div>
        <div class="sidebar-label">שתף</div>
        <app-ads-socialmedia [adsItem]="adsItem"></app-ads-socialmedia>
      </div>

    </div>

    <!-- ── Main content ── -->
    <div class="dlg-main">

      <!-- Loading -->
      @if (!sections) {
        <div class="dlg-loading">
          <div class="spinner-border text-primary" style="width:1.8rem;height:1.8rem;" role="status"></div>
          <span>טוען פרטי מודעה...</span>
        </div>
      }

      @if (sections) {
        @for (section of sections; track section) {
          <div class="section-block">
            @if (section.description) {
              <div class="section-title">
                {{ section.description }}
              </div>
            }
            <!-- Field grid -->
            <div class="section-fields">
              @for (question of section.questions; track question) {
                @switch (question.controlType) {
                  @case ('dropdown') {
                    <app-dropdown-field         [question]="question" [value]="question.value" [ngClass]="getClasses(question)"></app-dropdown-field>
                  }
                  @case ('checkbox') {
                    @if (isFieldEditable(question)) {
                      <label class="field-card edit-checkbox" [ngClass]="getClasses(question)">
                        <span class="field-label">{{ question.label }}</span>
                        <input type="checkbox" [(ngModel)]="editableValues[question.key]" [name]="'edit_' + question.key">
                      </label>
                    } @else {
                      <app-check-box-ads          [question]="question" [value]="question.value" [ngClass]="getClasses(question)"></app-check-box-ads>
                    }
                  }
                  @case ('textbox') {
                    @if (isFieldEditable(question)) {
                      <div class="field-card edit-field" [ngClass]="getClasses(question)">
                        <span class="field-label">{{ question.label }}</span>
                        <input type="text" class="edit-input" [(ngModel)]="editableValues[question.key]" [name]="'edit_' + question.key">
                      </div>
                    } @else {
                      <app-text-box-input          [question]="question" [value]="question.value" [ngClass]="getClasses(question)"></app-text-box-input>
                    }
                  }
                }
              }
            </div>
            <!-- Full-width fields -->
            <div class="section-fields-full">
              @for (question of section.questions; track question) {
                @switch (question.controlType) {
                  @case ('textarea') {
                    @if (isFieldEditable(question)) {
                      <div class="field-card-full edit-field">
                        <span class="field-label">{{ question.label }}</span>
                        <textarea class="edit-input edit-textarea" rows="4" [(ngModel)]="editableValues[question.key]" [name]="'edit_' + question.key"></textarea>
                      </div>
                    } @else {
                      <app-text-area-ads                             [question]="question" [value]="question.value"></app-text-area-ads>
                    }
                  }
                  @case ('imagesbox') {
                    <app-image-list-display                       [question]="question" [value]="question.value"></app-image-list-display>
                  }
                  @case ('selectrelateddescription') {
                    <app-select-related-description  [question]="question" [value]="question.value"></app-select-related-description>
                  }
                  @case ('bigselectbox') {
                    <app-big-select-box                         [question]="question" [value]="question.value"></app-big-select-box>
                  }
                  @case ('multiselectbox') {
                    <app-multi-select-box-ads                 [question]="question" [value]="question.value"></app-multi-select-box-ads>
                  }
                  @case ('personcontact') {
                    <app-person-contact-ads                    [question]="question" [value]="question.value"></app-person-contact-ads>
                  }
                }
              }
            </div>
          </div>
        }
      }

    </div>

  </div>
</div>
